import type { MapLayer } from "@/mocks/mapa";

interface MapLayerControlProps {
  layers: MapLayer[];
  onToggleLayer: (layerId: string) => void;
  open: boolean;
  onClose: () => void;
}

export default function MapLayerControl({ layers, onToggleLayer, open, onClose }: MapLayerControlProps) {
  if (!open) return null;

  const categorias = [
    { key: "individuos", label: "Indivíduos Arbóreos" },
    { key: "risco", label: "Classificação de Risco" },
    { key: "manejo", label: "Manejo Recomendado" },
    { key: "ambiental", label: "Áreas Ambientais" },
    { key: "projetos", label: "Projetos" },
    { key: "base", label: "Camadas Base" },
  ];

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose}></div>
      <div className="absolute top-12 right-2 w-72 bg-white border border-background-200 rounded-card shadow-lg z-50">
        <div className="flex items-center justify-between px-4 py-3 border-b border-background-200/70">
          <div className="flex items-center gap-2">
            <i className="ri-stack-line text-accent-500 text-base" aria-hidden="true"></i>
            <span className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">Camadas</span>
          </div>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors" title="Fechar">
            <i className="ri-close-line text-foreground-500 text-base"></i>
          </button>
        </div>

        <div className="p-3 space-y-3 max-h-80 overflow-y-auto">
          {categorias.map((cat) => {
            const catLayers = layers.filter((l) => l.categoria === cat.key);
            if (catLayers.length === 0) return null;
            return (
              <div key={cat.key}>
                <p className="text-[10px] font-semibold text-foreground-500 uppercase tracking-wider mb-1.5">{cat.label}</p>
                <div className="space-y-1">
                  {catLayers.map((layer) => (
                    <label
                      key={layer.id}
                      className="flex items-center gap-2.5 py-1.5 px-2 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
                    >
                      <div className="relative">
                        <input
                          type="checkbox"
                          checked={layer.ativa}
                          onChange={() => onToggleLayer(layer.id)}
                          className="sr-only"
                        />
                        <div className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-colors ${
                          layer.ativa
                            ? "bg-accent-500 border-accent-500"
                            : "border-background-300 bg-white"
                        }`}>
                          {layer.ativa && <i className="ri-check-line text-white text-[10px]"></i>}
                        </div>
                      </div>
                      <span
                        className="w-2.5 h-2.5 rounded-full shrink-0"
                        style={{ backgroundColor: layer.cor }}
                        aria-hidden="true"
                      ></span>
                      <span className="text-xs text-foreground-700 whitespace-nowrap">{layer.nome}</span>
                      <i className={`${layer.icone} text-foreground-400 text-xs ml-auto`} aria-hidden="true"></i>
                    </label>
                  ))}
                </div>
              </div>
            );
          })}

          {/* Base layer switcher */}
          <div className="pt-2 border-t border-background-200/70">
            <p className="text-[10px] font-semibold text-foreground-500 uppercase tracking-wider mb-1.5">Mapa Base</p>
            <div className="grid grid-cols-2 gap-1.5">
              <button className="text-xs py-2 px-3 rounded-md bg-accent-50 text-accent-700 font-medium border border-accent-200 whitespace-nowrap transition-colors">
                <i className="ri-map-line text-xs mr-1" aria-hidden="true"></i>
                OpenStreetMap
              </button>
              <button className="text-xs py-2 px-3 rounded-md bg-background-50 text-foreground-600 border border-background-200 hover:bg-background-100 whitespace-nowrap transition-colors">
                <i className="ri-earth-line text-xs mr-1" aria-hidden="true"></i>
                Satélite
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}